/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateFeaturedAlbumDto,
  FeaturedAlbumDto,
  FeaturedAlbumsControllerListAdminParams,
  FeaturedAlbumsControllerListParams,
  ReorderFeaturedAlbumsDto,
  UpdateFeaturedAlbumDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get active featured albums for a placement
 */
export const featuredAlbumsControllerList = (
  params: FeaturedAlbumsControllerListParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<FeaturedAlbumDto[]>(
    { url: `/featured-albums`, method: "GET", params, signal },
    options,
  );
};

export const getFeaturedAlbumsControllerListQueryKey = (
  params?: FeaturedAlbumsControllerListParams,
) => {
  return [`/featured-albums`, ...(params ? [params] : [])] as const;
};

export const getFeaturedAlbumsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: FeaturedAlbumsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFeaturedAlbumsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof featuredAlbumsControllerList>>
  > = ({ signal }) =>
    featuredAlbumsControllerList(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type FeaturedAlbumsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof featuredAlbumsControllerList>>
>;
export type FeaturedAlbumsControllerListQueryError = ErrorType<unknown>;

export function useFeaturedAlbumsControllerList<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: FeaturedAlbumsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
          TError,
          Awaited<ReturnType<typeof featuredAlbumsControllerList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useFeaturedAlbumsControllerList<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: FeaturedAlbumsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
          TError,
          Awaited<ReturnType<typeof featuredAlbumsControllerList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useFeaturedAlbumsControllerList<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: FeaturedAlbumsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get active featured albums for a placement
 */

export function useFeaturedAlbumsControllerList<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
  TError = ErrorType<unknown>,
>(
  params: FeaturedAlbumsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getFeaturedAlbumsControllerListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all featured albums (admin)
 */
export const featuredAlbumsControllerListAdmin = (
  params?: FeaturedAlbumsControllerListAdminParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<FeaturedAlbumDto[]>(
    { url: `/featured-albums/admin`, method: "GET", params, signal },
    options,
  );
};

export const getFeaturedAlbumsControllerListAdminQueryKey = (
  params?: FeaturedAlbumsControllerListAdminParams,
) => {
  return [`/featured-albums/admin`, ...(params ? [params] : [])] as const;
};

export const getFeaturedAlbumsControllerListAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
  TError = ErrorType<unknown>,
>(
  params?: FeaturedAlbumsControllerListAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFeaturedAlbumsControllerListAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>
  > = ({ signal }) =>
    featuredAlbumsControllerListAdmin(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type FeaturedAlbumsControllerListAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>
>;
export type FeaturedAlbumsControllerListAdminQueryError = ErrorType<unknown>;

export function useFeaturedAlbumsControllerListAdmin<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | FeaturedAlbumsControllerListAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
          TError,
          Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useFeaturedAlbumsControllerListAdmin<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
  TError = ErrorType<unknown>,
>(
  params?: FeaturedAlbumsControllerListAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
          TError,
          Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useFeaturedAlbumsControllerListAdmin<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
  TError = ErrorType<unknown>,
>(
  params?: FeaturedAlbumsControllerListAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all featured albums (admin)
 */

export function useFeaturedAlbumsControllerListAdmin<
  TData = Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
  TError = ErrorType<unknown>,
>(
  params?: FeaturedAlbumsControllerListAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof featuredAlbumsControllerListAdmin>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getFeaturedAlbumsControllerListAdminQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Feature an album in a placement (admin)
 */
export const featuredAlbumsControllerCreate = (
  createFeaturedAlbumDto: BodyType<CreateFeaturedAlbumDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<FeaturedAlbumDto>(
    {
      url: `/featured-albums/admin`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFeaturedAlbumDto,
      signal,
    },
    options,
  );
};

export const getFeaturedAlbumsControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof featuredAlbumsControllerCreate>>,
    TError,
    { data: BodyType<CreateFeaturedAlbumDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof featuredAlbumsControllerCreate>>,
  TError,
  { data: BodyType<CreateFeaturedAlbumDto> },
  TContext
> => {
  const mutationKey = ["featuredAlbumsControllerCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof featuredAlbumsControllerCreate>>,
    { data: BodyType<CreateFeaturedAlbumDto> }
  > = (props) => {
    const { data } = props ?? {};

    return featuredAlbumsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeaturedAlbumsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof featuredAlbumsControllerCreate>>
>;
export type FeaturedAlbumsControllerCreateMutationBody =
  BodyType<CreateFeaturedAlbumDto>;
export type FeaturedAlbumsControllerCreateMutationError = ErrorType<unknown>;

/**
 * @summary Feature an album in a placement (admin)
 */
export const useFeaturedAlbumsControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof featuredAlbumsControllerCreate>>,
      TError,
      { data: BodyType<CreateFeaturedAlbumDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof featuredAlbumsControllerCreate>>,
  TError,
  { data: BodyType<CreateFeaturedAlbumDto> },
  TContext
> => {
  const mutationOptions =
    getFeaturedAlbumsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reorder featured albums for a placement (admin)
 */
export const featuredAlbumsControllerReorder = (
  reorderFeaturedAlbumsDto: BodyType<ReorderFeaturedAlbumsDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/featured-albums/admin/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: reorderFeaturedAlbumsDto,
    },
    options,
  );
};

export const getFeaturedAlbumsControllerReorderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof featuredAlbumsControllerReorder>>,
    TError,
    { data: BodyType<ReorderFeaturedAlbumsDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof featuredAlbumsControllerReorder>>,
  TError,
  { data: BodyType<ReorderFeaturedAlbumsDto> },
  TContext
> => {
  const mutationKey = ["featuredAlbumsControllerReorder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof featuredAlbumsControllerReorder>>,
    { data: BodyType<ReorderFeaturedAlbumsDto> }
  > = (props) => {
    const { data } = props ?? {};

    return featuredAlbumsControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeaturedAlbumsControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof featuredAlbumsControllerReorder>>
>;
export type FeaturedAlbumsControllerReorderMutationBody =
  BodyType<ReorderFeaturedAlbumsDto>;
export type FeaturedAlbumsControllerReorderMutationError = ErrorType<unknown>;

/**
 * @summary Reorder featured albums for a placement (admin)
 */
export const useFeaturedAlbumsControllerReorder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof featuredAlbumsControllerReorder>>,
      TError,
      { data: BodyType<ReorderFeaturedAlbumsDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof featuredAlbumsControllerReorder>>,
  TError,
  { data: BodyType<ReorderFeaturedAlbumsDto> },
  TContext
> => {
  const mutationOptions =
    getFeaturedAlbumsControllerReorderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update a featured album (admin)
 */
export const featuredAlbumsControllerUpdate = (
  featuredAlbumId: string,
  updateFeaturedAlbumDto: BodyType<UpdateFeaturedAlbumDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<FeaturedAlbumDto>(
    {
      url: `/featured-albums/admin/${featuredAlbumId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateFeaturedAlbumDto,
    },
    options,
  );
};

export const getFeaturedAlbumsControllerUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof featuredAlbumsControllerUpdate>>,
    TError,
    { featuredAlbumId: string; data: BodyType<UpdateFeaturedAlbumDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof featuredAlbumsControllerUpdate>>,
  TError,
  { featuredAlbumId: string; data: BodyType<UpdateFeaturedAlbumDto> },
  TContext
> => {
  const mutationKey = ["featuredAlbumsControllerUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof featuredAlbumsControllerUpdate>>,
    { featuredAlbumId: string; data: BodyType<UpdateFeaturedAlbumDto> }
  > = (props) => {
    const { featuredAlbumId, data } = props ?? {};

    return featuredAlbumsControllerUpdate(
      featuredAlbumId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type FeaturedAlbumsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof featuredAlbumsControllerUpdate>>
>;
export type FeaturedAlbumsControllerUpdateMutationBody =
  BodyType<UpdateFeaturedAlbumDto>;
export type FeaturedAlbumsControllerUpdateMutationError = ErrorType<unknown>;

/**
 * @summary Update a featured album (admin)
 */
export const useFeaturedAlbumsControllerUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof featuredAlbumsControllerUpdate>>,
      TError,
      { featuredAlbumId: string; data: BodyType<UpdateFeaturedAlbumDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof featuredAlbumsControllerUpdate>>,
  TError,
  { featuredAlbumId: string; data: BodyType<UpdateFeaturedAlbumDto> },
  TContext
> => {
  const mutationOptions =
    getFeaturedAlbumsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove a featured album (admin)
 */
export const featuredAlbumsControllerRemove = (
  featuredAlbumId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/featured-albums/admin/${featuredAlbumId}`, method: "DELETE" },
    options,
  );
};

export const getFeaturedAlbumsControllerRemoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof featuredAlbumsControllerRemove>>,
    TError,
    { featuredAlbumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof featuredAlbumsControllerRemove>>,
  TError,
  { featuredAlbumId: string },
  TContext
> => {
  const mutationKey = ["featuredAlbumsControllerRemove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof featuredAlbumsControllerRemove>>,
    { featuredAlbumId: string }
  > = (props) => {
    const { featuredAlbumId } = props ?? {};

    return featuredAlbumsControllerRemove(featuredAlbumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FeaturedAlbumsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof featuredAlbumsControllerRemove>>
>;

export type FeaturedAlbumsControllerRemoveMutationError = ErrorType<unknown>;

/**
 * @summary Remove a featured album (admin)
 */
export const useFeaturedAlbumsControllerRemove = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof featuredAlbumsControllerRemove>>,
      TError,
      { featuredAlbumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof featuredAlbumsControllerRemove>>,
  TError,
  { featuredAlbumId: string },
  TContext
> => {
  const mutationOptions =
    getFeaturedAlbumsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
